import { render, staticRenderFns } from "./CanteenIdle.vue?vue&type=template&id=596d073a"
import script from "./CanteenIdle.vue?vue&type=script&lang=js"
export * from "./CanteenIdle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports